<template>
  <v-dialog v-model="isOpen" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t('serviceSettings.customService.iconLabel') }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <div class="IconPicker-iconContainer">
            <v-btn
              v-for="(icon, index) in iconList"
              :elevation="icon === selectedIcon ? '5' : ''"
              :key="index"
              icon
              @click="selectedIcon = icon"
            >
              <v-icon> {{ icon }} </v-icon>
            </v-btn>
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="cancelIcon">
          {{ $t('serviceSettings.customService.dialogClose') }}
        </v-btn>
        <v-btn color="primary" text @click="validIcon">
          {{ $t('serviceSettings.customService.dialogConfirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'IconPicker',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedIcon: '',
      iconList: [
        'mdi-glasses',
        'mdi-camera-outline',
        'mdi-magnify',
        'mdi-lan',
        'mdi-heart-outline',
        'mdi-home-outline',
        'mdi-earth',
        'mdi-map-marker-outline',
        'mdi-account-group',
        'mdi-chart-arc',
        'mdi-image-area',
        'mdi-cart',
        'mdi-weather-sunny',
        'mdi-cloud-outline',
        'mdi-phone',
        'mdi-forum-outline',
        'mdi-headphones',
        'mdi-calendar',
        'mdi-thumb-up-outline',
        'mdi-lightbulb-outline'
      ]
    }
  },
  methods: {
    cancelIcon() {
      this.selectedIcon = ''
      this.$emit('close')
    },
    validIcon() {
      this.$emit('input', this.selectedIcon)
      this.selectedIcon = ''
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.IconPicker-iconContainer {
  grid-template-columns: repeat(4, 1fr);
  display: grid;
  padding: 20px 50px;

  button {
    margin: 20px auto;
  }
}
</style>